import { alpha } from "@mui/system";

// Estilos do nó customizado de equipamento no diagrama
const styles = (theme) => ({
  // Cartão do nó customizado
  nodeCard: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 1,
    py: 0.75,
    borderRadius: 2,
    minWidth: 150,
    maxWidth: 200,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.divider}`,
  },
  // Bolinha do Badge de status (SNMP/PING) do host vinculado, ancorada no ícone do equipamento —
  // cor de fundo aplicada no componente
  hostStatusBadgeDot: {
    minWidth: 10,
    height: 10,
    borderRadius: "50%",
    border: `2px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows?.[1],
  },
  // Anel de selecao (box-shadow) e sempre aplicado; a borda azul de selecao so aparece quando o
  // node NAO tem cor de agrupamento propria — com cor, a borda continua mostrando o grupo, e o
  // anel ja comunica "selecionado" sem competir visualmente com a cor
  nodeCardSelected: {
    boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.2)}`,
  },
  nodeCardSelectedSemCor: {
    border: `2px solid ${theme.palette.primary.main}`,
  },
  nodeTooltip: {
    maxWidth: 360,
    overflow: "visible",
  },
  // Título dos dois tooltips do node (status do host / observações) — mesmo padrão do tooltip
  // "Atendimentos Excedidos" de fluxoAtendimentoEtapaComponent: negrito + common.white explícito.
  // O balão do MUI Tooltip é sempre escuro (fundo/texto fixos, não seguem o tema — ver
  // Tooltip.js/tooltipClasses: backgroundColor alpha(grey[700],.92) + color common.white sempre),
  // então qualquer texto aqui dentro tem que usar common.white (ou nada, herda), nunca
  // text.primary/text.secondary — esses invertem com o tema e podem ficar ilegíveis nesse fundo
  // sempre escuro (era exatamente esse tipo de bug que deixava esse texto difícil de ler)
  nodeTooltipTitle: {
    fontWeight: 600,
    fontSize: 13,
    color: theme.palette.common.white,
    mb: 0.5,
  },
  // Painel de fundo dedicado ao corpo do texto (mesmo papel do Paper de cada item em
  // "Atendimentos Excedidos"): uma sobreposição preta translúcida fixa sobre o balão, que já é
  // escuro nos dois temas — cria contraste sempre, sem precisar ramificar por theme.palette.mode
  nodeTooltipContent: {
    maxHeight: 200,
    overflowY: "auto",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    backgroundColor: alpha(theme.palette.common.black, 0.25),
    borderRadius: 1,
    p: 1,
    color: theme.palette.common.white,
  },
  // Conteúdo do tooltip do pontinho de status do host vinculado
  statusTooltipContent: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    backgroundColor: alpha(theme.palette.common.black, 0.25),
    borderRadius: 1,
    p: 1,
  },
  statusTooltipLine: {
    fontSize: 12,
    color: theme.palette.common.white,
  },
  statusTooltipChips: {
    display: "flex",
    gap: 0.5,
    mt: 0.25,
  },
  nodeIconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 34,
    borderRadius: "50%",
    flexShrink: 0,
    overflow: "hidden",
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
  nodeIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
  // Ícone customizado (upload) enquadrado dentro do mesmo círculo dos ícones fixos
  nodeIconCustom: {
    width: "100%",
    height: "100%",
    "& .MuiAvatar-img": {
      objectFit: "cover",
    },
  },
  nodeTextBox: {
    minWidth: 0,
  },
  nodeName: {
    fontSize: 12,
    fontWeight: 700,
    maxWidth: 110,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.text.primary,
  },
  nodeSecondLine: {
    fontSize: 11,
    fontWeight: 500,
    maxWidth: 110,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.text.secondary,
  },
  // Pontos de conexão dos nós
  handle: {
    width: 8,
    height: 8,
    backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.background.paper}`,
  },
});

export default styles;
